export default __webpack_public_path__ + "static/media/iconApps.858db46a.svg";